import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EmailCustomizationService } from 'src/app/shared/services/email-customization.service';
import { EmailScenario } from '../models/emailCustomization';

@Injectable()
export class EmailCustomizationResolver {
  constructor(private emailCustomizationService: EmailCustomizationService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const teamId = route.params.id ? route.params.id : route.parent.params.id;
    const scenario = route.paramMap.get('scenario') as EmailScenario;
    return this.emailCustomizationService.getTeamEmailCustomization(teamId, scenario);
  }
}
